


















































































import axios from 'axios';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import Banner from '@/components/CFP/Banner.vue';
import BulletScreen from '@/components/CFP/BulletScreen.vue';

import { ThemeType } from '@/store/types/app';

import head from '@/util/head';

@Component({
  components: {
    Banner,
    BulletScreen
  }
})
export default class CFP extends Vue {
  @Action('toggleTheme', { namespace: 'app' }) private toggleTheme!: (theme: ThemeType) => void;
  @Getter('isPopup', { namespace: 'app' }) private isPopup!: boolean;

  private defineString: string = '';
  private onSend: boolean = false;
  private bulletScreenWidth: number = 0;
  private bulletScreenHeight: number = 0;

  @Watch('isPopup')
  public onChangePopup (newVal: boolean) {
    if (!newVal) { this.setMeta(); }
  }

  public mounted () {
    this.setMeta();
    this.measureBulletScreenSize();
    window.addEventListener('resize', this.measureBulletScreenSize);
  }

  public destroyed () {
    window.removeEventListener('resize', this.measureBulletScreenSize);
  }

  private toggleSendAnimate (): void {
    this.onSend = true;
    setTimeout(() => {
      this.defineString = '';
      this.onSend = false;
    }, 3000);
  }

  private measureBulletScreenSize (): void {
    const bulletScreen: any = this.$refs.bulletScreen;

    this.bulletScreenWidth = bulletScreen.clientWidth;
    this.bulletScreenHeight = bulletScreen.clientHeight;
  }

  private async sendDefineForm (): Promise<void> {
    if (this.defineString) {
      try {
        // Detect Egg
        if (this.defineString.toLowerCase().trim().replace(/ /g, '') === 'genderequality') {
          this.toggleTheme(ThemeType.RAINBOW_DARK);
        }

        const defineString = this.defineString;
        this.toggleSendAnimate();
        await axios.post(`https://docs.google.com/forms/d/e/1FAIpQLSf60kH6sRpI_7ctpKi8ptcI7cG2OpvGmW3SjWUGcyiDEekQ4w/formResponse?entry.2121946644=${defineString}`);
      } catch (error) {
        // tslint:disable:no-console
        console.error('Google Form POST', error);
        // tslint:enable
      }
    }
  }

  private setMeta (): void {
    head.title('Call for Paper｜稿件徵求中！');
    head.ogTitle('Call for Paper｜稿件徵求中！');
    head.ogDescription('SITCON 2020 邀請身為學生的你，向大家分享您的經驗與技術，期待您能在演講桌前，與我們一起 #define student。');
    head.ogUrl('https://sitcon.org/2020/cfp/');
    head.ogImage('https://sitcon.org/2020/img/cfp-og.png');
  }
}
